import {
  WorkOutline,
  GroupOutlined,
  QueryStatsOutlined,
  KeyboardVoiceOutlined,
  Troubleshoot,
  AccountCircleOutlined,
  AssignmentOutlined,
  HomeOutlined
} from '@mui/icons-material';

// Function to get nav items with dynamic paths based on role and clientId
const getNavItems = (role, clientId) => [
  {
    // Customer Workspace - visible to customers (client role) only
    icon: HomeOutlined,
    label: 'Home',
    path: '/home',
    roles: ["client"],
  },
  {
    icon: WorkOutline,
    label: 'Jobs',
    path: '/jobs',
    roles: ["Admin", "client", "Recruiter", "Account Manager"],
  },
  {
    icon: AssignmentOutlined,
    label: 'Post Hiring',
    path: '/offer-joiner',
    roles: ["client"],
  },
  {
    icon: GroupOutlined,
    label: 'Talent Pool',
    path: role === 'client' ? `/talent-pool/${clientId}` : '/talent-pool',
    roles: ["Admin", "Recruiter", "Account Manager"],
  },
  {
    icon: QueryStatsOutlined,
    label: 'Market Intel',
    path: '/market-intel',
    roles: ["Admin", "Recruiter", "Account Manager", "client"],
  },
  {
    icon: KeyboardVoiceOutlined,
    label: 'Interview',
    path: '/interviewList',
    roles: ["Admin", "Recruiter", "Account Manager", "client"],
  },
  {
    icon: AssignmentOutlined,
    label: 'Analytics',
    path: '/analytics',
    roles: ["client"],
  },
  {
    icon: Troubleshoot,
    label: 'Analytics',
    path: '/analytics',
    roles: ["Admin", "Account Manager", "Recruiter"],
  },
  {
    icon: AccountCircleOutlined,
    label: 'Account',
    path: '/account-view',
    roles: ["Admin", "client", "Account Manager", "Recruiter"],
  },
  
];

// Default export for backward compatibility
const navItems = getNavItems();

export { getNavItems };
export default navItems;
